import {createTheme, responsiveFontSizes} from "@mui/material";
import {orange} from "@mui/material/colors";
import IranSans from "../assets/fonts/IRANSans.woff2";

const Theme = responsiveFontSizes(createTheme({
    status: {
        danger: orange[500],
    },
    direction: 'rtl',
    typography: {
        fontFamily: [
            'IRANSans',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: `
        @font-face {
          font-family: 'IRANSansFaNum';
          font-style: normal;
          font-display: swap;
          font-weight: 200;
          src: local('IRANSansFaNum'), local('IRANSansFaNum'), url(${IranSans}) format('woff2');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }`,
        },
    }

}));


export default Theme;